module.exports = __webpack_public_path__ + "./img/mute.a5aa120eefb8ec0bf5d2adbedb73e580.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/mute.png
// module id = ./assets/images/mute.png
// module chunks = 0